import React from 'react'
import { colors } from '../../theme'

export function EyeOfLine() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_2105_3230)">
        <path
          fill={colors.white}
          d="M17.882 19.297A10.949 10.949 0 0112 21c-5.392 0-9.878-3.88-10.82-9a10.982 10.982 0 013.34-6.066L1.393 2.808l1.415-1.415 19.799 19.8-1.415 1.414-3.31-3.31zM5.935 7.35A8.965 8.965 0 003.223 12a9.005 9.005 0 0013.2 5.838l-2.027-2.028A4.5 4.5 0 018.19 9.604L5.935 7.35zm6.979 6.978l-3.242-3.242a2.5 2.5 0 003.24 3.241l.002.001zm7.893 2.264l-1.431-1.43a8.934 8.934 0 001.4-3.162A9.006 9.006 0 009.553 5.338L7.974 3.76C9.22 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.946 10.946 0 01-2.012 4.592zm-9.084-9.084a4.5 4.5 0 014.769 4.769l-4.77-4.769z"
        />
      </g>
      <defs>
        <clipPath id="clip0_2105_3230">
          <path fill="#fff" d="M0 0H24V24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
